import React from 'react';
import { getAllGames, isGamePlayEnabled } from '../../data/games';

function GameSelector({ activeGame, onSelect }) {
  const games = getAllGames();

  return (
    <div className="flex flex-wrap justify-center gap-2 py-6 px-4">
      {games.map((game) => {
        const isActive = activeGame === game.id;
        const isDisabled = !isGamePlayEnabled(game.id);
        return (
          <button
            key={game.id}
            type="button"
            disabled={isDisabled}
            onClick={() => {
              if (!isDisabled) onSelect(game.id);
            }}
            title={isDisabled ? 'Coming soon' : undefined}
            className={`flex items-center gap-2 px-4 py-2.5 rounded-xl text-sm font-semibold transition-all ${
              isDisabled
                ? 'cursor-not-allowed border border-gray-700/50 bg-dark-surface/30 text-gray-600 opacity-50'
                : isActive
                  ? 'cursor-pointer bg-gradient-to-r from-hash-gold/20 to-medora-blue/20 border border-hash-gold/40 text-white shadow-gold-glow'
                  : 'cursor-pointer bg-dark-surface/50 border border-white/5 text-gray-400 hover:text-white hover:border-hash-gold/20'
            }`}
          >
            <img
              src={game.icon}
              alt=""
              className={`w-7 h-7 md:w-8 md:h-8 object-contain ${isDisabled ? 'opacity-40' : ''}`}
            />
            <img
              src={game.textImage}
              alt={game.shortName}
              className={`h-5 md:h-6 w-auto object-contain ${isDisabled ? 'opacity-40' : ''}`}
            />
          </button>
        );
      })}
    </div>
  );
}

export default GameSelector;
